export type ProcessStep = {
  n: string;
  title: string;
  body: string;
};

/**
 * Themed 4-up process grid, mirroring the homepage `steps` block and the
 * `process-step-item` pattern used on the SEO theme service pages.
 */
export function ProcessSteps({ steps, eyebrow }: { steps: ProcessStep[]; eyebrow?: string }) {
  if (!steps.length) return null;
  return (
    <section className="demo-process-grid not-prose my-14">
      {eyebrow && <p className="demo-section-label mb-6">{eyebrow}</p>}
      <div className="row g-4">
        {steps.map((s) => (
          <div key={s.n} className="col-12 col-sm-6 col-lg-3">
            <div className="demo-process-card d-flex flex-column gap-4 h-100 min-h-[260px] border border-border bg-background px-6 py-8 transition-colors hover:bg-card sm:px-7 sm:py-9">
              <span className="font-display text-2xl leading-none text-muted-foreground">
                {s.n}
              </span>
              <h3 className="m-0 font-display text-xl leading-tight">{s.title}</h3>
              <p className="m-0 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
